var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$vuetify.breakpoint.mdAndUp ? _c('div', {
    staticClass: "top_info"
  }, [_c('div', {
    staticClass: "data"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Active Stake")]), _c('div', {
    staticClass: "content"
  }, [_vm.inDCM ? _c('p', [_vm._v(_vm._s(_vm.convertNum(_vm.inDCM)) + " DCM")]) : _c('p', [_vm._v("N/A")])]), _c('div', {
    staticClass: "desc"
  }, [_vm.currentSupply && _vm.inDCM ? _c('p', [_c('span', {
    style: {
      fontWeight: 'bolder'
    }
  }, [_vm._v("Locked Stake")]), _c('br'), _vm._v(" $ " + _vm._s(_vm.lockedStake.toLocaleString('en-US')) + " "), _c('b', [_vm._v("USD")])]) : _c('p', [_vm._v("N/A")])])]), _c('div', {
    staticClass: "chart chart-area"
  }, [_c('VueApexChartsComponent', {
    ref: "apex",
    attrs: {
      "type": "radialBar",
      "height": "200",
      "options": _vm.chartOptions,
      "series": [_vm.series]
    }
  })], 1)]) : _c('div', {
    staticClass: "top_info"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Active Stake")]), _c('div', {
    staticClass: "content"
  }, [_vm.totalStake ? _c('p', [_vm._v(_vm._s(_vm.inDCM.toLocaleString('en-US')))]) : _c('p', [_vm._v("N/A")])]), _c('div', {
    staticClass: "desc"
  }, [_vm.totalStake ? _c('p', [_vm._v(_vm._s(_vm.totalStake.stake))]) : _c('p', [_vm._v("N/A")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }